
  import Vue from "vue";
  import lookupsService from "@/services/lookupsService";
  import dogRegistrationService from "@/services/dogRegistrationService";
  import FooterText from "@/components/common/FooterText.vue";
  import DatepickerFormatted from '@/components/common/inputs/DatepickerFormatted.vue';
  import DogRegistrationFeeTable from "@/components/Portal/DogRegistrationFeeTable.vue";
  import { UserInfo } from "@/types/User";
  import { debounce } from "throttle-debounce";
  const defaultImage = require('@/assets/photouploadblue.png');
  export default Vue.extend({
    name: "DogInformation",
    components: { FooterText, DatepickerFormatted, DogRegistrationFeeTable },
    props: {
      changePage: Function,
      dogInfo: Object,
      puppyInfo: Object,
      dogsLookups: Object,
      setDogRegistrationFee: Function,
      price: Number,
      priceInfo: Array,
    },
    created: function() {
      this.reloadData();
    },
    data: function () {
      return {
        defaultImage,
        isValid: false,
        showResults: [] as any[],
        colors: {},
        validationResult: {},
      }
    },
    
  watch: {
    "dogInfo.officialName": {
      handler: debounce(
        2000,
        function (this: any, newVal: string, oldVal: string) {
          console.log('dogInfo.officialName')
          console.log(newVal)
          console.log(oldVal)
          if (newVal === oldVal) return;
          if (newVal) { 
            dogRegistrationService.calculatePuppyRegistrafionFee({requesterPersonId: this.userInfo.personId, puppyId: this.puppyInfo.puppyId, officialName: this.dogInfo.officialName})
            .then(res => {
              this.setDogRegistrationFee(res)}
            );           
            dogRegistrationService.validateDogName(
              this.puppyInfo.puppyId,
              this.dogInfo.officialName
            ).then(validationResult => {
                this.validationResult = validationResult;                    
            });
           }
        }),
      },
    },
    computed: {
      userInfo(): UserInfo {
        return this.$store.state.userInfo;
      },
    },
    methods: {
      reloadData: function() {
        lookupsService.getDogsAttributes().then((res) => {
          this.colors = res;
        });
      },
      updateBirthDate: function (val: any) {
        this.dogInfo.birthDate = val.date;
        //workaround to force rerendering after setting up formatted date
        this.$set(this, "showResults", this.showResults);
      },
      getIsValid() {
        return this.isValid && !!this.dogInfo.breed;
      }
    }
  });
  